import React, { useEffect, createElement } from 'react';
import { SummerCampHero } from './summer-camp/SummerCampHero';
import { SummerCampTrustBar } from './summer-camp/SummerCampTrustBar';
import { SummerCampKeyInfo } from './summer-camp/SummerCampKeyInfo';
import { SummerCampBenefits } from './summer-camp/SummerCampBenefits';
import { SummerCampWhatKidsDo } from './summer-camp/SummerCampWhatKidsDo';
import { SummerCampWeeklySessions } from './summer-camp/SummerCampWeeklySessions';
import { SummerCampWhatKindOfCamp } from './summer-camp/SummerCampWhatKindOfCamp';
import { SummerCampPricing } from './summer-camp/SummerCampPricing';
import { SummerCampBringAndPickup } from './summer-camp/SummerCampBringAndPickup';
import { SummerCampWhyParents } from './summer-camp/SummerCampWhyParents';
import { SummerCampReviews } from './summer-camp/SummerCampReviews';
import { SummerCampLocation } from './summer-camp/SummerCampLocation';
import { SummerCampFAQHeader } from './summer-camp/SummerCampFAQHeader';
import { SummerCampFAQQuestions } from './summer-camp/SummerCampFAQQuestions';
import { SummerCampRelatedLinks } from './summer-camp/SummerCampRelatedLinks';
import { SummerCampFinalCTA } from './summer-camp/SummerCampFinalCTA';
export function SummerCamp() {
  useEffect(() => {
    document.title = 'Storm Taekwondo Summer Camp 2026 | Farmington Hills, MI';
    const metaDesc = document.querySelector('meta[name="description"]');
    const content = 'Storm Taekwondo Martial Arts Summer Camp 2026 in Farmington Hills. Weekly sessions for ages 6+, Mon–Fri 10–4. Shirts included, pay weekly or daily. Text 517-225-9501 to register.';
    if (metaDesc) {
      metaDesc.setAttribute('content', content);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = content;
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-3366">
      <SummerCampHero data-id="element-3367" />
      <SummerCampTrustBar data-id="element-3368" />
      <SummerCampKeyInfo data-id="element-3369" />
      <SummerCampBenefits data-id="element-3370" />
      <SummerCampWhatKidsDo data-id="element-3371" />
      <SummerCampWeeklySessions data-id="element-3372" />
      <SummerCampWhatKindOfCamp data-id="element-3373" />
      <SummerCampPricing data-id="element-3374" />
      <SummerCampBringAndPickup data-id="element-3375" />
      <SummerCampWhyParents data-id="element-3376" />
      <SummerCampReviews data-id="element-3377" />
      <SummerCampLocation data-id="element-3378" />
      <section className="py-24 bg-off-white" data-id="element-3379">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3380">
          <SummerCampFAQHeader data-id="element-3381" />
          <SummerCampFAQQuestions data-id="element-3382" />
        </div>
      </section>
      <SummerCampRelatedLinks data-id="element-3383" />
      <SummerCampFinalCTA data-id="element-3384" />
    </div>;
}